import type { Fallacy } from "./types";
import { createStory } from "./types";

export const prisonersDilemma: Fallacy = {
    id: "prisoners-dilemma",
    name: "Prisoner's Dilemma Thinking",
    emoji: "🔒",
    category: "Jebakan Strategi",
    description: "Asumsi semua orang pasti mengkhianati, jadi **kita duluan** — padahal **kerja sama lebih menguntungkan**.",
    tldr: "\"Mendingan khianatin duluan sebelum dikhianatin\" — padahal kerja sama bisa lebih untung.",
    detail: "Prisoner's Dilemma Thinking terjadi ketika seseorang berasumsi pihak lain pasti bertindak egois, sehingga merasa harus **\"menyerang duluan\"** sebagai strategi bertahan. Pola pikir ini berakar dari teori permainan klasik di mana dua tahanan memilih: bekerja sama atau saling mengkhianati.\n\nIroninya, karena semua pihak berpikir seperti ini, hasil terburuk malah terwujud. Ini menjadi self-fulfilling prophecy: **ketidakpercayaan melahirkan pengkhianatan**, yang memperkuat ketidakpercayaan. Padahal riset menunjukkan strategi kooperatif seperti \"tit-for-tat\" jauh lebih menguntungkan dalam jangka panjang.\n\nKunci menghindarinya: kebanyakan interaksi bukan permainan satu kali. Reputasi dan hubungan jangka panjang membuat kerja sama lebih rasional daripada pengkhianatan preventif.",
    story: createStory("Prisoner's Dilemma Thinking", "🔒", {
      hook: {
        title: "\"Mendingan khianatin duluan.\"",
        body: "Sebelum dikhianatin orang, mendingan kita duluan yang main curang... bener gak sih?",
      },
      convo: {
        claim: "Temen ngajak patungan sewa villa buat liburan, lebih murah per orang. Tapi aku ogah, **ntar aku bayar duluan terus yang lain kabur** dan aku yang nanggung.",
        response: "Ini temen kamu, bukan stranger. **Curiga duluan justru yang bikin hubungan rusak.**",
      },
      reveal: {
        body: "Kamu asumsi semua orang pasti main curang, jadi kamu **\"serang duluan\"**. Ironinya, justru ini yang bikin semua pihak rugi.",
      },
      insight: {
        title: "Padahal...",
        body: "Kebanyakan hubungan itu jangka panjang. Curiga duluan justru **bikin self-fulfilling prophecy** — kamu yang rusak hubungannya sendiri.",
      },
      engagement: {
        title: "Pernah nolak kerja sama karena takut dimanfaatin? 🔒",
        body: "Di kerjaan atau pertemanan? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["zero-sum-bias", "free-rider", "false-dilemma"],
  };
